import PropTypes from 'prop-types'
import React, { useEffect, useState, useCallback } from 'react'
import Router from 'next/router'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { SEGMENT_STORAGE_KEY_CATEGORY } from 'lib/segment/const'
import {
  CATEGORY_TAB_DATA,
  CATEGORY_TAB_DATA_2,
  CATEGORY_TAB_IDS,
  CATEGORY_TAB_IDS_2,
} from 'pages/category/const'
import Typo from 'constants/typography'
import styles from './style.scss'

const filterTabs = ({
  categoryList,
  country,
  categoryID,
  language,
  includeENButton = false,
}) =>
  categoryList.reduce((filteredData, category) => {
    const hasElligibleShop = !!category.elligibleShops?.length
    const isElligibleShop = category.elligibleShops.includes(country)

    const isAllowCategory = category?.showOnCategoryID
      ? category.showOnCategoryID.includes(categoryID)
      : categoryID === category.categoryId

    if (
      !isAllowCategory ||
      (isAllowCategory && hasElligibleShop && !isElligibleShop)
    ) {
      return filteredData
    }

    return [
      ...filteredData,
      {
        name:
          category.buttonText[language] ||
          (includeENButton && category.buttonText.en),
        id: category.categoryId,
        link: category.link,
      },
    ]
  }, [])

const CategoryTabList = ({ categoryID, setPageOne, internationalization }) => {
  const [categoryData, setCategoryData] = useState([])
  const { country, language } = internationalization

  const redirectToCategory = useCallback(
    (id, alias, e) => {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      setPageOne()
      sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.type, 'no_track')
      Router.push(`/category?id=${id}`, `/${country}/${language}/${alias}`)
    },
    [country, language, setPageOne],
  )

  useEffect(() => {
    let filteredTabs = []

    if (CATEGORY_TAB_IDS.includes(categoryID)) {
      filteredTabs = filterTabs({
        categoryList: CATEGORY_TAB_DATA,
        categoryID,
        country,
        language,
        includeENButton: true,
      })
    } else if (CATEGORY_TAB_IDS_2.includes(categoryID)) {
      filteredTabs = filterTabs({
        categoryList: CATEGORY_TAB_DATA_2,
        categoryID,
        country,
        language,
      })
    }

    setCategoryData(filteredTabs)
  }, [categoryID, country, language])

  useEffect(() => {
    if (
      categoryData.length > 0 &&
      categoryData?.every((category) => category.id !== categoryID)
    ) {
      const [firstCategory] = categoryData
      redirectToCategory(firstCategory.id, firstCategory.link)
    }
  }, [categoryID, categoryData, redirectToCategory])

  if (!categoryData?.length) {
    return null
  }

  return (
    <div className="category-list">
      <style jsx>{styles}</style>
      {categoryData.map((category) => (
        <div
          key={category.id}
          className={clsx(Typo.subtitle1, 'category-swiper', {
            active: categoryID === category.id,
          })}
          role="presentation"
          onClick={(e) => redirectToCategory(category.id, category.link, e)}
        >
          {category.name}
        </div>
      ))}
    </div>
  )
}

CategoryTabList.propTypes = {
  categoryID: PropTypes.number.isRequired,
  setPageOne: PropTypes.func.isRequired,
  internationalization: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
}

export { CategoryTabList }

export default connect(
  /* istanbul ignore next */
  (state) => ({
    internationalization: state.internationalization,
  }),
)(CategoryTabList)
